module.exports = vendor;


//////////////////
// WEBPACK FOOTER
// external "vendor"
// module id = +qWx
// module chunks = 12